import { api, apiEndPoints } from "../../api/index";

export const getMarquee = async () => {
    const clientId=process.env.REACT_APP_PUBLIC_CLIENT
    const response = await api.get(`${apiEndPoints.marquee}?search=${clientId}`);
    return {data:response?.data};
}
